import { Link } from 'react-router-dom';
import styles from './LinkMenu.module.scss';

interface LinkProps {
  children: React.ReactNode;
  to: string;
}

export default function LinkMenu({ children, to }: LinkProps): JSX.Element {
  return (
    <Link to={to} className={styles.linkContainer}>
      {children}
    </Link>
  );
}
